import styled from 'styled-components';

export const ReactionAnimatedImage = styled.img(({ theme: { size } }) => ({
  width: size.units(3.5),
  height: size.units(3.5),
  objectFit: 'contain',
}));

export const StyledReactionButton = styled.button<{ $cooldown: boolean }>(
  ({ theme: { color, size, transition }, $cooldown }) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: size.units(5),
    height: size.units(5),
    minWidth: size.units(5),
    minHeight: size.units(5),
    borderRadius: size.units(10),
    border: 'none',
    backgroundColor: 'transparent',
    WebkitTapHighlightColor: 'transparent',
    cursor: $cooldown ? 'default' : 'pointer',
    fontSize: size.units(3),
    opacity: $cooldown ? 0.4 : 1,
    transition: transition.standard('background', 'opacity', 'transform'),
    userSelect: 'none',

    ...(!$cooldown && {
      '&:active': {
        transform: 'scale(1.3)',
      },
    }),

    '&:hover': {
      backgroundColor: color.background.primary.hover(0.2),
    },
  }),
);
